import Vue from 'vue'
import ScrollMagic from 'scrollmagic'

const appearController = new ScrollMagic.Controller()

export const appearElement = function (el, offset) {
  offset = (typeof offset === 'number') ? offset : 0
  let scene = new ScrollMagic.Scene({triggerElement: el, triggerHook: "onEnter", offset: offset})
  scene.addTo(appearController)
  scene.on('enter', function () {
    el.classList.add('appear')
    scene.destroy()
  });
}

export default {
  name: 'Appear',
  inserted (el, binding) {
    appearElement(el, binding.value)
  }
}


// WEBPACK FOOTER //
// ./assets/js/library/appear.js